import { Inject, Optional, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LOCAL_STORAGE_VARIABLES, STAFF_TYPE } from '../../../../shared/constants';
import { BaseLoopBackApiService } from '../base.service';

@Injectable()
export class AccountLoopBackApiService extends BaseLoopBackApiService {

  modelName = 'Accounts';
  /**
   * Check if current user is an admin
   */
  public isAdmin() {
    return this.isAuthenticated() && this.getCurrentUser() && this.getCurrentUser().type == STAFF_TYPE.ADMIN;
  }

  /**
   * Check if current user is logged
   */
  public isAuthenticated(): any {
    return this.storageService.getAccessToken();
  }

  /**
   * Get current user data
   */
  public getCurrentUser(): any {
    return this.storageService.getCurrentUser();
  }

  /**
   * Login a user with username/email and password.
   *
   * @param credentials
   * @param include
   */
  public login(credentials: any, include: any) {
    let options = {
      pathUrl: 'login',
      body: credentials
    };
    if (include !== undefined) {
      options['params'] = { include: include };
    }

    return this.post(options);
  }

  /**
   * Logout a user with accessToken
   */
  public logout() {
    let options = {
      pathUrl: 'logout',
      body: {
        accessToken: this.storageService.getAccessToken(),
      }
    };
    return this.post(options);
  }

  /**
   * Reset password of a user
   * @param email
   */
  public resetPassword(email: string) {
    let options = {
      pathUrl: 'reset',
      body: {
        email: email,
      }
    };
    return this.post(options);
  }

  /**
   * Get current user from Api server
   */
  public getCurrent() {
    let options = {
      pathUrl: ':id',
      urlParams: {
        id: this.storageService.getUserId(),
      }
    };
    return this.get(options);
  }

  /**
   * Send token and introduction to user
   * @param email
   */
  public sendToken(email: string): any {
    let options = {
      pathUrl: 'sendToken',
      body: {
        email: email,
      }
    };
    return this.post(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api/loopback/custom/account.service.ts